"use client";
import { motion } from "motion/react";
import { useFilter } from "@/app/context/FilterContext";

export default function HomeDimWrapper({ children }: { children: React.ReactNode }) {
  const { isWheelOpen } = useFilter();
  return (
    <motion.div
      animate={{ opacity: isWheelOpen ? 0.35 : 1, pointerEvents: isWheelOpen ? "none" : "auto" }}
      transition={{ duration: 0.25 }}
    >
      {children}
    </motion.div>
  );
}
